// extracted by mini-css-extract-plugin
module.exports = {"contractCard":"contracts_contractCard__1pYYF","contractInfo":"contracts_contractInfo__oHbrL","badge":"contracts_badge__2Xbwx","noContract":"contracts_noContract__3NO0s"};